import { Box } from "@mui/material";
import MobileOffIcon from "@mui/icons-material/MobileOff";

const MobilePage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundColor: "#f0f0f0",
      }}
    >
      <Box
        style={{
          textAlign: "center",
        }}
      >
        <MobileOffIcon style={{ fontSize: "100px", color: "#555" }} />
        <br />
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
          Mobile View Not Supported
        </span>
      </Box>
    </div>
  );
};

export default MobilePage;
